"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var config_1 = require("./config");
var WRAP = String.fromCharCode(10);
var setCodeBlock = function (editor, language) {
    var _a = editor.view, state = _a.state, dispatch = _a.dispatch;
    var schema = state.schema, selection = state.selection, doc = state.doc;
    var from = selection.from, to = selection.to, $from = selection.$from;
    var selectTextLen = doc.textBetween(from, to, WRAP).length;
    var tr = state.tr;
    var codeText = '';
    var start;
    var end;
    doc.nodesBetween(from, to, function (node, pos) {
        if (node.isTextblock) {
            if (start === undefined) {
                start = pos;
            }
            end = pos + node.nodeSize;
            node.content.forEach(function (child) {
                if (child.isText)
                    codeText += child.textContent;
                if (child.type.name === 'break')
                    codeText += WRAP;
            });
            codeText += WRAP;
            return false;
        }
    });
    codeText = codeText.substring(0, codeText.length - 1);
    if (start === undefined || end === undefined)
        return;
    var newCode = schema.nodes.code_block.create(language ? { language: language } : undefined, codeText ? schema.text(codeText) : undefined);
    var $start = editor.view.state.doc.resolve(start);
    var $end = editor.view.state.doc.resolve(end);
    var newFrom = from;
    // 非顶层切割需要补位,在第一个节点应当视为在顶层
    if ($start.depth && $start.indexAfter()) {
        newFrom += $start.depth;
    }
    else {
        newFrom -= $from.depth - 1;
    }
    // 嵌套元素的头尾需要把父级包括进去
    if ($start.depth && !$start.indexAfter()) {
        start = $start.pos - $start.depth;
    }
    if ($end.depth && $end.indexAfter() === $end.parent.childCount) {
        end = $end.pos + $end.depth;
    }
    tr = tr.replaceRangeWith(start, end, newCode);
    dispatch(tr.setSelection(core_utilities_1.TextSelection.create(tr.doc, newFrom, newFrom + selectTextLen)));
    editor.focus();
};
var clearCodeBlock = function (editor) {
    var _a = editor.view, dispatch = _a.dispatch, state = _a.state;
    var schema = state.schema, tr = state.tr, selection = state.selection;
    var $from = selection.$from, $to = selection.$to;
    var node = $from.node();
    var nodePos = $from.before();
    var textContents = node.textContent.split(WRAP);
    var fragments = textContents.reduce(function (res, text) {
        if (text) {
            res.push(schema.text(text));
        }
        res.push(schema.nodes.break.create());
        return res;
    }, []);
    fragments.pop();
    dispatch(tr
        .replaceRangeWith(nodePos, nodePos + node.nodeSize, schema.nodes.paragraph.create(undefined, fragments))
        .setSelection(core_utilities_1.TextSelection.create(tr.doc, $from.pos, $to.pos)));
    editor.focus();
};
var CodeBlockController = /** @class */ (function (_super) {
    __extends(CodeBlockController, _super);
    function CodeBlockController(editor, store, props) {
        var _this = _super.call(this, editor, store, props) || this;
        _this.name = config_1.PLUGIN_NAME;
        _this.toolbar = {
            className: config_1.PLUGIN_NAME,
            tooltip: config_1.PLUGIN_NAME,
            handler: function (editor) {
                var $from = editor.view.state.selection.$from;
                if ($from.parent.type.name === config_1.PLUGIN_NAME) {
                    _this.command.clearCodeBlock(editor);
                }
                else {
                    _this.command.setCodeBlock(editor, _this.props.mode);
                }
            }
        };
        _this.command = {
            setCodeBlock: function (editor, mode) {
                setCodeBlock(editor, mode || _this.props.mode);
                _this.props.afterInsert && _this.props.afterInsert(editor);
            },
            clearCodeBlock: function (editor) {
                clearCodeBlock(editor);
            }
        };
        config_1.setConfig(props);
        return _this;
    }
    return CodeBlockController;
}(core_utilities_1.SylController));
exports.CodeBlockController = CodeBlockController;
//# sourceMappingURL=controller.js.map